import { useDropzone } from "react-dropzone";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";

// ----------------------------------------------------------------------

export default function UploadCV({
  disabled,
  multiple = false,
  error,
  helperText,
  //
  file,
  onDelete,
  //
  files,
  thumbnail,
  fileName,
  onUpload,
  onRemove,
  onRemoveAll,
  sx,
  accept,
  ...other
}) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject,
    fileRejections,
  } = useDropzone({
    multiple,
    disabled,
    accept,
    ...other,
  });

  const hasFile = !!file && !multiple;

  const hasError = isDragReject || !!error;

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePreview = (event) => {
    event.preventDefault();
    const newWindow = window.open(
      file?.toString(),
      "_blank",
      "noopener,noreferrer"
    );
    if (newWindow) newWindow.opener = null;
  };

  const renderSinglePreview = (
    <Stack direction="row" columnGap={0.5} alignItems="center">
      <img src="/assets/icons/ic_document.svg" className="w-6 h-6" />
      <Typography
        onClick={handlePreview}
        variant="body1"
        mr={2}
        fontWeight={600}
        color="#037CCF"
        sx={{
          p: 1,
          borderRadius: 1,
          "&:hover": {
            bgcolor: "#E6F2FA",
          },
        }}
      >
        {fileName}
      </Typography>
    </Stack>
  );

  const renderPlaceholder = (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
    >
      <Stack
        spacing={1}
        sx={{
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack justifyContent="space-between" alignItems="center">
          <Stack flexDirection="row" gap={1} alignItems="center">
            <img
              src="/assets/icons/ic_upload.svg"
              className="w-6 h-6 sm:w-12 sm:h-12"
              style={{ color: "#919191", mb: 1 }}
            />
            <Typography fontWeight={400}>
              Tải lên CV từ máy tính, chọn hoặc kéo thả
            </Typography>
          </Stack>
          <Typography variant="body1" color="#64748B">
            Hỗ trợ định dạng pdf có kích thước dưới 5MB
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center">
          {hasFile && renderSinglePreview}
          {!hasFile && (
            <Button
              variant="contained"
              size="large"
              sx={{
                height: 44,
                fontSize: 16,
                fontWeight: 500,
                bgcolor: "#27C6FF",
                color: "#fff",
                borderRadius: "30px",
                textTransform: "none",
                px: 4,
              }}
            >
              Chọn CV
            </Button>
          )}
        </Stack>
        {!isMobile && (
          <Typography variant="body2" fontWeight={500}>
            Giới hạn dung lượng file: 5MB
          </Typography>
        )}
      </Stack>
    </Stack>
  );

  const removeSinglePreview = hasFile && onDelete && (
    <IconButton
      size="small"
      onClick={onDelete}
      sx={{
        top: 16,
        right: 16,
        zIndex: 9,
        position: "absolute",
        color: (theme) => alpha(theme.palette.common.white, 0.8),
        bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
        "&:hover": {
          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48),
        },
      }}
    >
      <img src="/assets/icons/ic_document.svg" className="w-6 h-6" />
    </IconButton>
  );

  return (
    <Box sx={{ width: 1, position: "relative", ...sx }}>
      <Box
        {...getRootProps()}
        sx={{
          outline: "none",
          borderRadius: 1,
          cursor: "pointer",
          overflow: "hidden",
          position: "relative",

          transition: (theme) =>
            theme.transitions.create(["opacity", "padding"]),

          ...(isDragActive && {
            opacity: 0.72,
          }),
          ...(disabled && {
            opacity: 0.48,
            pointerEvents: "none",
          }),
          ...(hasError && {
            color: "error.main",
            borderColor: "error.main",
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
          }),
        }}
      >
        <input {...getInputProps()} />

        {/* {hasFile ? renderSinglePreview : renderPlaceholder} */}
        {renderPlaceholder}
      </Box>

      {removeSinglePreview}

      {helperText && helperText}

      {/* <RejectionFiles fileRejections={fileRejections} /> */}
    </Box>
  );
}
